module.exports = __webpack_public_path__ + "img/97.b9a9db52.jpg";